import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import s from './SignalTranslationEquation.module.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { initialSignalTranslationEquationState } from '../../reducers/initialState';
import { v4 as uuidv4 } from 'uuid';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import Banner from '../Banner/Banner';
import { Link, useParams, Navigate, href } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Checkbox from '../WSAControls/CheckboxContainer/Checkbox';
import ModelCategoryConfigurationContentTemplate from '../ModelCategoryTab/ModelCategoryConfigurationContentTemplate';
import classNames from 'classnames';
import { isRequired } from '../../utils';
import { v4 as uuid } from 'uuid';
import Cookies from 'js-cookie';
import EquationConstantTable from './EquationConstantTable';
import { IsWidgetAccessible } from '../../utils/widgetManager';
import Breadcrumb from '../WSAControls/Breadcrumb/BreadCrumb'


const SignalTranslationEquation = ({
  saveSignalTranslationEquation,
  describeSignalTranslationEquation,
  signalTranslationEquationManager = { ...initialSignalTranslationEquationState.signalTranslationEquation },
  changeSignalTranslationEquation,
  cleanUpSignalTranslationEquation,
  setSignalTranslationEquationConstantList,
  changeSignalTranslationEquationConstant,
  setSignalTranslationEquationCustomError,
  showAddEditScreen,
  userProfileWidgets,
  intl
}) => {
  let IsEdit = false;
  let IsRedirect = false;
  const [localformErrors, setFormErrors] = useState({});
  const [currentEquationConstantId, setCurrentEquationConstantId] = useState(-1);
  const [currentEquationConstantIdentifier, setCurrentEquationConstantIdentifier] = useState('');
  const envName = process.env.REACT_APP_ENV_NAME_SHORT;
  const isUpdateAllowed = IsWidgetAccessible(userProfileWidgets, 'SIGNALTRANSLATIONEQUATIONEDIT');

  let { SignalTranslationEquationId, ModelCategoryId } = useParams();

  if (SignalTranslationEquationId && SignalTranslationEquationId > 0) {
    IsEdit = true;
  }

  let widgetCode = IsEdit ? 'SIGNALTRANSLATIONEQUATIONEDIT' : 'SIGNALTRANSLATIONEQUATIONCONSTADD';
  useEffect(() => {
    if (SignalTranslationEquationId && parseInt(SignalTranslationEquationId) > 0) {
      describeSignalTranslationEquation(SignalTranslationEquationId, ModelCategoryId);
    }
  }, [describeSignalTranslationEquation, SignalTranslationEquationId, ModelCategoryId]);

  useEffect(() => {
    return () => {
      cleanUpSignalTranslationEquation();
    };
  }, []);

  // Update redux store
  const setLocalSignalTranslationEquation = currentState => {
    changeSignalTranslationEquation(currentState);
  };
  //Saving
  const submitForm = e => {
    e.preventDefault();

    if (!validateInput()) {
      return;
    }

    let saveData = {
      SignalTranslationEquationId: signalTranslationEquationManager.SelectedSignalTranslationEquation.SignalTranslationEquationId,
      Name: signalTranslationEquationManager.SelectedSignalTranslationEquation.Name,
      Description: signalTranslationEquationManager.SelectedSignalTranslationEquation.Description,
      Formula: signalTranslationEquationManager.SelectedSignalTranslationEquation.Formula,
      IsActive: signalTranslationEquationManager.SelectedSignalTranslationEquation.IsActive,
      ModelCategoryId: ModelCategoryId,
      SignalTranslationEquationConstants:
        (signalTranslationEquationManager.SelectedSignalTranslationEquation.EquationConstants &&
          signalTranslationEquationManager.SelectedSignalTranslationEquation.EquationConstants.EquationConstantList) ||
        []
    };

    saveData.IsEdit = IsEdit;
    saveData.UpdatedBy = Cookies.get(`userid-${envName}`) || 0;

    if (!IsEdit) {
      saveData.SignalTranslationEquationId = 0;
      saveData.GuidIdentifier = uuidv4();
    }
    //saving Model Variant
    saveSignalTranslationEquation(saveData, widgetCode);
  };

  const validateInput = () => {
    let formErrors = {};
    let isValid = true;

    if (
      !signalTranslationEquationManager ||
      !signalTranslationEquationManager.SelectedSignalTranslationEquation ||
      !signalTranslationEquationManager.SelectedSignalTranslationEquation.Name ||
      isRequired(signalTranslationEquationManager.SelectedSignalTranslationEquation.Name, 1)
    ) {
      formErrors.Name = intl.formatMessage({
        id: 'signalTranslationEquation.nameMandatory',
        defaultMessage: 'Equation name is mandatory field'
      });
      isValid = false;
    }

    if (
      !signalTranslationEquationManager ||
      !signalTranslationEquationManager.SelectedSignalTranslationEquation ||
      !signalTranslationEquationManager.SelectedSignalTranslationEquation.Formula ||
      isRequired(signalTranslationEquationManager.SelectedSignalTranslationEquation.Formula, 1)
    ) {
      formErrors.Formula = intl.formatMessage({
        id: 'signalTranslationEquation.formulaMandatory',
        defaultMessage: 'Formula name is mandatory field'
      });
      isValid = false;
    }

    setFormErrors(formErrors);

    return isValid;
  };

  //on control value change
  const onChange = e => {
    if (e.target && e.target.type && e.target.type === 'checkbox') {
      setLocalSignalTranslationEquation({
        ...signalTranslationEquationManager,
        SelectedSignalTranslationEquation: { ...signalTranslationEquationManager.SelectedSignalTranslationEquation, [e.target.name]: e.target.checked }
      });
    } else {
      setLocalSignalTranslationEquation({
        ...signalTranslationEquationManager,
        SelectedSignalTranslationEquation: { ...signalTranslationEquationManager.SelectedSignalTranslationEquation, [e.target.name]: e.target.value }
      });
    }
  };

  const setEditHandler = (equationConstantId, identifer) => {
    if (equationConstantId > -1) {
      setCurrentEquationConstantId(equationConstantId);
      setCurrentEquationConstantIdentifier(identifer);
      const constantList =
        (signalTranslationEquationManager.SelectedSignalTranslationEquation.EquationConstants &&
          signalTranslationEquationManager.SelectedSignalTranslationEquation.EquationConstants.EquationConstantList) ||
        [];
      let constantEquation = constantList.filter(item => {
        if (item.GuidIdentifier === identifer) return item;
      });
      if (constantEquation.length > 0) {
        changeSignalTranslationEquationConstant({
          SelectedEquationConstant: constantEquation[0]
        });
        showAddEditScreen(true);
      }
    } else {
      let data = initialSignalTranslationEquationState.signalTranslationEquation.SelectedSignalTranslationEquation.EquationConstants.SelectedEquationConstant;
      setCurrentEquationConstantId(-1);
      setCurrentEquationConstantIdentifier('');
      showAddEditScreen(false);
      changeSignalTranslationEquationConstant({
        SelectedEquationConstant: data
      });
    }
  };

  const setAddHandler = () => {
    let data = initialSignalTranslationEquationState.signalTranslationEquation.SelectedSignalTranslationEquation.EquationConstants.SelectedEquationConstant;
    data.SignalTranslationEquationId = parseInt(SignalTranslationEquationId);
    showAddEditScreen(true);
    changeSignalTranslationEquationConstant({
      SelectedEquationConstant: data
    });
    setCurrentEquationConstantId(0);
    setCurrentEquationConstantIdentifier('');
  };

  const disableModeHandler = status => { };

  const updateSignalTranslationEquationConstantConstant = status => { };

  let messageId = (signalTranslationEquationManager && signalTranslationEquationManager.displayMessageCode) || 'none';
  const messageText = intl.formatMessage({ id: messageId, defaultMessage: messageId });

  const breadcrumbItems = [
    { label: <FormattedMessage id="modelcategory.modelcategory" defaultMessage="Model Category" />, href: '/operational-setup/model-category-list' },
    { label: <FormattedMessage id="signalTranslationEquation.signalTranslationEquations" defaultMessage="Signal Translation Equations" />, href: `/operational-setup/model-category-configuration/${ModelCategoryId}/signal-translation-equation-list` },
    { label: <FormattedMessage id="signalTranslationEquation.newSignalTranslation" defaultMessage="New signalTranslation equation configuration" /> } // Last item has no href (current page)
  ];

  return (
    <div className={s.signalTranslationequation}>
      {signalTranslationEquationManager.isLoading && <LoadingSpinner />}
      {signalTranslationEquationManager.isOpSuccessful && !signalTranslationEquationManager.showBanner ? (
        <Navigate to={`/operational-setup/model-category-configuration/${ModelCategoryId}/signal-translation-equation-list`} />
      ) : (
        ''
      )}
      {IsRedirect ? <Navigate to={`/operational-setup/model-category-configuration/${ModelCategoryId}/signal-translation-equation-list`} /> : ''}
      <Banner
        key={uuid()}
        failureText={messageText}
        showBanner={signalTranslationEquationManager.showBanner}
        status={signalTranslationEquationManager.isOpSuccessful}
        successText={messageText}
      />

      <ModelCategoryConfigurationContentTemplate selectedPage="manageSignalTranslations" userProfileWidgets={userProfileWidgets}>
        <div className={s.contentWrapper}>
          <div className={s.signalTranslationequationHeader}>
            {/* <Link className={s.backLink} to={`/operational-setup/model-category-configuration/${ModelCategoryId}/signal-translation-equation-list`}>
              &lt; &nbsp;
              <FormattedMessage id="signalTranslationEquation.backToSignalTranslations" defaultMessage="BACK TO SIGNALTRANSLATIONS" />
            </Link> */}
            <h3 data-unittest="headingLabel">
              <FormattedMessage id="signalTranslationEquation.newSignalTranslation" defaultMessage="New signalTranslation equation configuration" />
            </h3>
            <div >
              <Breadcrumb items={breadcrumbItems} />
            </div>
          </div>
          <div className={s.signalTranslationequationContent}>
            <Form>
              <Row>
                <Col lg={6}>
                  <Form.Group controlId="formSignalTranslationEquationName">
                    <Form.Label>
                      <FormattedMessage id="signalTranslationEquation.name" defaultMessage="Name" />
                    </Form.Label>

                    <Form.Control
                      type="text"
                      name="Name"
                      onChange={onChange}
                      value={signalTranslationEquationManager.SelectedSignalTranslationEquation.Name}
                      className={`${s.formControl} ${localformErrors && localformErrors.Name ? s.formControlError : ''}`}
                    />
                    {localformErrors && localformErrors.Name && (
                      <p role="alert" className={s.error}>
                        {localformErrors.Name}
                      </p>
                    )}
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col lg={6}>
                  <Form.Group controlId="formSignalTranslationEquationDescription">
                    <Form.Label>
                      <FormattedMessage id="signalTranslationEquation.description" defaultMessage="Description" />
                    </Form.Label>

                    <Form.Control
                      as="textarea"
                      rows="3"
                      name="Description"
                      onChange={onChange}
                      placeholder={intl.formatMessage({
                        id: 'signalTranslationEquation.enterDescription',
                        defaultMessage: 'Enter description'
                      })}
                      value={signalTranslationEquationManager.SelectedSignalTranslationEquation.Description}
                      className={`${s.textArea} ${localformErrors && localformErrors.Description ? s.formControlError : ''}`}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col lg={6}>
                  <Form.Group controlId="formSignalTranslationEquationFormula">
                    <Form.Label>
                      <FormattedMessage id="signalTranslationEquation.formula" defaultMessage="Formula" />
                    </Form.Label>

                    <Form.Control
                      type="text"
                      name="Formula"
                      onChange={onChange}
                      value={signalTranslationEquationManager.SelectedSignalTranslationEquation.Formula}
                      className={`${s.formControl} ${localformErrors && localformErrors.Formula ? s.formControlError : ''}`}
                    />
                    <p role="alert" className={s.info}>
                      eg: {'{m}*{x} + {c}  =  mx+c'}{' '}
                    </p>
                    <p role="alert" className={s.info}>
                      eg: {'{x}**3 + {m}*{x}**2 - {c}  =    x³ + mx² -c'}{' '}
                    </p>
                    {localformErrors && localformErrors.Formula && (
                      <p role="alert" className={s.error}>
                        {localformErrors.Formula}
                      </p>
                    )}
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group controlId="formActiveSignalTranslationEquation">
                    <Checkbox
                      key={uuidv4()}
                      dataArray={[
                        {
                          SKEY: 'IsActive',
                          target: { type: 'checkbox' },
                          label: intl.formatMessage({
                            id: 'signalTranslationEquation.active',
                            defaultMessage: 'Equation is active'
                          }),
                          isChecked: signalTranslationEquationManager.SelectedSignalTranslationEquation.IsActive
                        }
                      ]}
                      onSelectionChange={onChange}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col sm={12}>
                  <div>
                    <EquationConstantTable
                      SelectedSignalTranslationEquationConstant={signalTranslationEquationManager.SelectedSignalTranslationEquation.EquationConstants}
                      setEditHandler={setEditHandler}
                      setSignalTranslationEquationCustomError={setSignalTranslationEquationCustomError}
                      disableMode={signalTranslationEquationManager.SelectedSignalTranslationEquation.EquationConstants.showAddEditScreen}
                      disableModeHandler={disableModeHandler}
                      selectedSignalTranslationEquationConstantId={currentEquationConstantId}
                      selectedEquationConstantIdentifier={currentEquationConstantIdentifier}
                      changeSignalTranslationEquationConstant={changeSignalTranslationEquationConstant}
                      setSignalTranslationEquationConstantList={setSignalTranslationEquationConstantList}
                      updateSignalTranslationEquationConstantConstant={updateSignalTranslationEquationConstantConstant}
                      userProfileWidgets={userProfileWidgets}
                      UpdateAllowed={isUpdateAllowed}
                      setAddHandler={setAddHandler}
                    />
                  </div>
                </Col>
              </Row>
              <Row className={s.breakRow}>
                <Col sm={12}>
                  <Button
                    variant="primary"
                    className={classNames(s.margin5, s.btnSaveChanges)}
                    onClick={submitForm}
                    noValidate
                    data-unittest="saveData"
                  >
                    <FormattedMessage id="signalTranslationEquation.saveSignalTranslationEquation" defaultMessage="SAVE CHANGES" />
                  </Button>
                  <Link to={`/operational-setup/model-category-configuration/${ModelCategoryId}/signal-translation-equation-list`}>
                    <Button variant="outline-secondary" className={s.btnCancel}>
                      <FormattedMessage id="signalTranslationEquation.cancelSignalTranslationEquation" defaultMessage="CANCEL" />
                    </Button>
                  </Link>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      </ModelCategoryConfigurationContentTemplate>
    </div>
  );
};

SignalTranslationEquation.propTypes = {
  saveSignalTranslationEquation: PropTypes.func.isRequired,
  signalTranslationEquationManager: PropTypes.object.isRequired,
  describeSignalTranslationEquation: PropTypes.func.isRequired,
  changeSignalTranslationEquation: PropTypes.func.isRequired
};

export default injectIntl(SignalTranslationEquation);
